import classnames from 'classnames';
import React, { useEffect, useMemo, useState } from 'react';
import SwiperCore from 'swiper';
import { Navigation, Pagination, A11y } from 'swiper/modules';
import { Swiper as SwiperLib, SwiperSlide } from 'swiper/react';
import "./BaseSwiper.css";
import styles from "./BaseSwiper.module.js";

// A11y will generate a new id with every run, so we cannot use snapshot testing while it is active
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
if (process.env.NODE_ENV === 'test') {
  SwiperCore.use([Navigation, Pagination]);
} else {
  SwiperCore.use([Navigation, Pagination, A11y]);
}
export function BaseSwiper({
  slides,
  spaceBetweenDefault = 50,
  onActiveIndexChange,
  activeSlideIndex = 0,
  swiperProps,
  children
}) {
  const [swiperInstance, setSwiperInstance] = useState(null);
  useEffect(() => {
    if (!swiperInstance || swiperInstance.destroyed) {
      return;
    }
    swiperInstance.slideTo(activeSlideIndex);
  }, [activeSlideIndex, swiperInstance]);
  const memoizedSlides = useMemo(() => {
    return slides.map(({
      element,
      id
    }) => /*#__PURE__*/_jsx(SwiperSlide, {
      children: element
    }, id));
  }, [slides]);
  return /*#__PURE__*/_jsxs(SwiperLib, {
    spaceBetween: spaceBetweenDefault,
    initialSlide: activeSlideIndex,
    onActiveIndexChange: swiperProps => onActiveIndexChange?.(swiperProps.activeIndex),
    onSwiper: swiperInstance => {
      setSwiperInstance(swiperInstance);
    },
    centerInsufficientSlides: true,
    watchOverflow: true,
    ...swiperProps,
    children: [memoizedSlides, children]
  });
}
export function BaseSwiperContainer({
  className,
  children
}) {
  return /*#__PURE__*/_jsx("div", {
    className: classnames(styles.swiperContainer, className),
    children: children
  });
}